import { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'src/utils/i18n'
import { getLocalAndroidAll } from 'src/@api/dashboard'
import Image from 'next/image'
import Link from 'next/link'
import { useSelector } from 'react-redux'

const PermissionCheck = () => {
  const { t } = useTranslation('commonAndroidLocal')
  const [isLoading, setIsLoading] = useState(true)
  const selectedDeviceUserId = useSelector(state => state.Common.deviceUser)
  const isDisconnectFromStore = useSelector(state => state.Common.isDisconnect)
  const getStoredUserData = () => JSON.parse(localStorage.getItem('userData'))?.data
  const getStoredDeviceUser = () => {
    const saved = localStorage.getItem('DeviceUser')

    return saved ? JSON.parse(saved) : null
  }
  const deviceUserRef = useRef(getStoredDeviceUser())

  const [isShow, setIsShow] = useState(false) //是否展示提示警告
  const [showList, setShowList] = useState([]) //未开权限列表
  const [isSeeMore, setIsSeeMore] = useState(false) //展开显示
  const [isDisconnect, setIsDisconnect] = useState(true) //设备是否断开连接
  const PermissionList = [
    { name: t('Accessibility'), data: 'ACCESSIBILITY' },
    { name: t('Camera'), data: 'CAMERA' },
    { name: t('Location'), data: 'SYSTEM_LOCATION' },
    { name: t('Location access'), data: 'LOCATION' },
    { name: t('SMS'), data: 'SMS' },
    { name: t('Call log'), data: 'CALL_LOG' },
    { name: t('Photos and videos'), data: 'PHOTO_LIBRARY' },
    { name: t('Microphone'), data: 'MICROPHONE' },
    { name: t('Contact'), data: 'CONTACT' },
    { name: t('Calendar'), data: 'CALENDAR' },
    { name: t('Priority'), data: 'PRIORITY' },
    { name: t('Screenshot'), data: 'SCREENSHOT' },
    { name: t('Notice'), data: 'NOTICE' },
    { name: t('Usage data'), data: 'USAGE_DATA' },
  ]

  const getData = async () => {
    const username = getStoredUserData()
    const deviceUdid = deviceUserRef.current?.username
    if (!username?.email || !deviceUdid) {
      setIsShow(false)
      setIsLoading(false)

      return
    }

    setIsLoading(true)
    const result = await getLocalAndroidAll({
      username: username.email,
      params: {
        category: 'PERMISSION_LIST',
        deviceUdid
      }
    })
    const list = result.data.contents || {}
    const filteredPermissions = PermissionList.filter(item => list[item.data] === 0 || !(item.data in list))
    if (filteredPermissions.length > 0) {
      setShowList(filteredPermissions)
      setIsShow(true)
    } else setIsShow(false)
    setIsLoading(false)
  }

  // 设备切换时重新拉权限；断连状态优先读 Redux
  useEffect(() => {
    deviceUserRef.current = getStoredDeviceUser()
    setIsSeeMore(false)
    setIsDisconnect(isDisconnectFromStore)
    getData()
  }, [selectedDeviceUserId, isDisconnectFromStore])

  return (
    <>
      {isShow && !isLoading && !isDisconnect &&
        <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] p-[18px] mb-[20px]'>
          <div className='flex items-start'>
            <Image src='/images/common/warn.svg' width={22} height={22} alt='warning'></Image>
            <div className='ml-[18px]'>
              <p className='text-[13px] text-[#222222] font-[600] mb-2'>{t('Some permissions are missing')}</p>
              <p className='text-[12px] text-[#999999] my-1'>
                {t('This means Msafely cant update data for certain features')}
              </p>
              <div className='flex items-center cursor-pointer' onClick={() => setIsSeeMore(!isSeeMore)}>
                <span className='text-[13px] text-[#5035FF] font-[600] mr-[5px]'>{isSeeMore ? t('Show less') : t('Show more')}</span>
                <Image src={isSeeMore ? '/images/common/pull-up2.svg' : '/images/common/drop-down2.svg'} width={12} height={12} alt='drop down'></Image>
              </div>
            </div>
          </div>
          {isSeeMore &&
            <div className='mt-[18px] w-full bg-[#F5F6F7] rounded-[6px] p-4'>
              <p className='text-[18px] text-[#282938] font-[600] mb-2'>{t('How do I fix it')}</p>
              <div className='text-[13px] text-[#333333]'>
                <p>{t('Youll need to re-enable')}</p>
                {showList.map((it, i) => {
                  return (
                    <p key={i} className='mt-[6px]'>●&nbsp;&nbsp;{it.name}</p>
                  )
                })}
                <p className='mt-4'>
                  {t('Go to')}&nbsp;
                  <Link href='/android/local/permission-check' className='text-[#5035FF] font-[600]'
                    onClick={() => {
                    }}>
                    {t('Permission Check')}
                  </Link>
                  &nbsp;{t('to see the setting paths')}</p>
              </div>
            </div>}
        </div>}
    </>
  )
}

export default PermissionCheck

